import { apiCall } from './generated/gqlClient';

const INVOICE_TEMPLATE_FIELDS = `
  id
  providerId
  enabled
  docType
  logoFileId
  header
  footer
  fields
  numberPrefix
  numberNext
  legalName
  taxId
  billingAddressId
  language
  autoSend
  updatedAt
`;

const INVOICE_LIST_FIELDS = `
  id
  providerId
  orderId
  number
  issuedAt
  netCents
  taxCents
  grossCents
  currency
  pdfFileId
  status
  emailSentAt
  customerName
`;

export const getInvoiceTemplateApiRequest = async (fragments = null) =>
  apiCall({
    query: `query getInvoiceTemplate { getInvoiceTemplate { ${INVOICE_TEMPLATE_FIELDS} ...fragments } }`,
    variables: {},
    fragments,
  });

export const upsertInvoiceTemplateApiRequest = async ({ input }, fragments = null) =>
  apiCall({
    query: `mutation upsertInvoiceTemplate($input: ProviderInvoiceTemplateInput!) { upsertInvoiceTemplate(input: $input) { ${INVOICE_TEMPLATE_FIELDS} ...fragments } }`,
    variables: { input },
    fragments,
  });

export const getProviderInvoicesApiRequest = async ({ from, to, customerId }, fragments = null) =>
  apiCall({
    query: `query getProviderInvoices($from: String, $to: String, $customerId: Int) { getProviderInvoices(from: $from, to: $to, customerId: $customerId) { ${INVOICE_LIST_FIELDS} ...fragments } }`,
    variables: { from, to, customerId },
    fragments,
  });

export const getInvoiceByOrderApiRequest = async ({ orderId }, fragments = null) =>
  apiCall({
    query: `query getInvoiceByOrder($orderId: Int!) { getInvoiceByOrder(orderId: $orderId) { ${INVOICE_LIST_FIELDS} ...fragments } }`,
    variables: { orderId },
    fragments,
  });

export const getInvoiceApiRequest = async ({ id }, fragments = null) =>
  apiCall({
    query: `query getInvoice($id: Int!) { getInvoice(id: $id) { id providerId orderId number issuedAt customerSnapshot providerSnapshot lines netCents taxCents grossCents currency pdfFileId status emailSentAt createdAt ...fragments } }`,
    variables: { id },
    fragments,
  });

export const resendInvoiceApiRequest = async ({ invoiceId }, fragments = null) =>
  apiCall({
    query: `mutation resendInvoice($invoiceId: Int!) { resendInvoice(invoiceId: $invoiceId) { success message id id2 name status ...fragments } }`,
    variables: { invoiceId },
    fragments,
  });

export const generateInvoiceApiRequest = async ({ orderId }, fragments = null) =>
  apiCall({
    query: `mutation generateInvoice($orderId: Int!) { generateInvoice(orderId: $orderId) { success message id id2 name status ...fragments } }`,
    variables: { orderId },
    fragments,
  });

export const updateInvoiceApiRequest = async ({ invoiceId, number, linesJson }, fragments = null) =>
  apiCall({
    query: `mutation updateInvoice($invoiceId: Int!, $number: String, $linesJson: String) { updateInvoice(invoiceId: $invoiceId, number: $number, linesJson: $linesJson) { success message id id2 name status ...fragments } }`,
    variables: { invoiceId, number, linesJson },
    fragments,
  });

export const sendTestInvoiceApiRequest = async (fragments = null) =>
  apiCall({
    query: `mutation sendTestInvoice { sendTestInvoice { success message id ...fragments } }`,
    variables: {},
    fragments,
  });
